import { styled } from "styled-components";

export const StyledAppsContainerSidebarUserCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center !important;
  justify-content: center !important;
`;

export const StyledAppsContainerSidebarUserCardFooter = styled.div`
  padding: 5px 20px;
  border-top: 1px solid ${({ theme }) => theme.palette.borderColor};
`;

export const StyledAppsContainerSidebarCover = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledAppsContainerSidebarAvatar = styled.div<{
  avatarSize: number;
}>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  & .ant-avatar {
    margin-bottom: 10px;
    height: ${({ avatarSize }) => avatarSize}px !important;
    width: ${({ avatarSize }) => avatarSize}px !important;
    border-radius: 50% !important;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;

    img {
      border-radius: 0% !important;
      height: 100% !important;
      width: 100% !important;
    }
  }
`;
